export default function () {
    this.loadOrder()
}
